import React, { ReactElement } from 'react'
import Input from '../../../components/Input'
import { DeleteIcon } from '../../../conf/images'
import './InputItem.css'

interface InputItemProps {
    value: string
    onChange?: (value: string) => void
    onDelete?: () => void
    deleteable?: boolean
    className?: string
    disabled?: boolean
    placeholder?: string
    autoFocus?: boolean
    prefix?: ReactElement
    multiple?: boolean
}
const InputItem: React.FC<InputItemProps> = (props) => {
    const {
        value = '',
        onChange = () => undefined,
        onDelete = () => undefined,
        deleteable = false,
        className = '',
        prefix,
        disabled,
        multiple = true,
        autoFocus,
        placeholder,
    } = props

    return (
        <Input
            className={`input-item ${className}`}
            placeholder={placeholder}
            multiple={multiple}
            prefix={prefix}
            value={value}
            disabled={disabled}
            maxLength={500}
            onChange={(value) => onChange(value)}
            autoFocus={autoFocus}
            after={
                deleteable &&
                !disabled && (
                    <img
                        className='delete-button'
                        src={DeleteIcon}
                        alt='x'
                        onClick={() => onDelete()}
                    />
                )
            }
        />
    )
}
export default InputItem
